module.exports = __webpack_public_path__ + "static/media/chevron-right.7811de93.svg";